
import { useQueries } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useGetPrivateAnalysesSubmittersQueries = ({ analyses }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useQueries({
    queries: analyses.map(({ id }) => {
      return {
        queryKey: ['privateAnalyses', { relationship: 'submitter', id }],
        queryFn: () => api.analysisSubmitter({ id }),
        enabled: options.enabled !== false && id && Object.keys(analyses).length > 0,
        refetchOnWindowFocus: false,
        select: (data) => {
          const clonedData = structuredClone(data)
          return {
            ...clonedData,
            analysisId: id
          }
        },
        ...options
      }
    })
  })
}
